import { CustomLabelsAttribute } from '@app/analyze-data/enums/custom-labels-attribute.enum';

/** Mirrors CustomLabelRulePDO::TARGET_FIELD_ALIASES (lib/feedonomics/model/CustomLabelRulePDO.php).
 *  Google/Microsoft exports spell custom-label attributes in camelCase; every other export
 *  spells them snake_case. Both spellings resolve to the same canonical target field. */
const CUSTOM_LABEL_TARGET_FIELD_ALIASES: Readonly<Record<string, CustomLabelsAttribute>> = {
    [CustomLabelsAttribute.CustomLabel0]: CustomLabelsAttribute.CustomLabel0,
    customLabel0: CustomLabelsAttribute.CustomLabel0,
    [CustomLabelsAttribute.CustomLabel1]: CustomLabelsAttribute.CustomLabel1,
    customLabel1: CustomLabelsAttribute.CustomLabel1,
    [CustomLabelsAttribute.CustomLabel2]: CustomLabelsAttribute.CustomLabel2,
    customLabel2: CustomLabelsAttribute.CustomLabel2,
    [CustomLabelsAttribute.CustomLabel3]: CustomLabelsAttribute.CustomLabel3,
    customLabel3: CustomLabelsAttribute.CustomLabel3,
    [CustomLabelsAttribute.CustomLabel4]: CustomLabelsAttribute.CustomLabel4,
    customLabel4: CustomLabelsAttribute.CustomLabel4
};

/**
 * Resolves a raw field name (a DB field name or an export's `export_field_name`) to its
 * canonical Custom Label target field, accepting either the snake_case or Google/Microsoft
 * camelCase spelling. Returns null when the name isn't a custom-label attribute in either
 * spelling.
 */
export function resolveCustomLabelTargetField(fieldName: string | null | undefined): CustomLabelsAttribute | null {
    if (!fieldName) {
        return null;
    }
    return CUSTOM_LABEL_TARGET_FIELD_ALIASES[fieldName] ?? null;
}
